import {getAuth} from 'firebase/auth';

export const refreshAuthToken = async (): Promise<string | null> => {
  const auth = getAuth();
  if (!auth.currentUser) {
    return null;
  }
  try {
    const token = await auth.currentUser.getIdToken(true);
    return token;
  } catch (error) {
    console.error('Error refreshing token:', error);
    return null;
  }
};
